import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { POOLSIDE_OPTIONS } from './constants';
import {
  PageStyles,
  SubtitleStyles,
  TitleStyles,
} from './PoolsideScreen.styles';

export const PoolsideScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Poolside',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const poolside = form.watch('poolside');

  const handleChange = (option: OnbOptionType<LayoutDataType['poolside']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        poolside: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-pool/poolside/background.jpg`}
          alt="AI Character"
        />
      }
      background="dark-solid"
    >
      <IonContent>
        <SubtitleStyles>She glances at you and smiles:</SubtitleStyles>
        <TitleStyles>I like when people watch me work!</TitleStyles>
        <OnboardingOptionsList>
          {POOLSIDE_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={poolside === option.id}
              control={form.control}
              option={option}
              name="poolside"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`poolside-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </PageStyles>
  );
};
